export default __webpack_public_path__ + "812cb3294e04909a08b5478cb13837d8.svg";